const INITIAL_STATE = {
  filiadoTO: null,
  alerta: {},
  esperandoSolicitacao: false
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_CONTATO_CLOSE_MESSAGE':
      return { ...state, alerta: {} };
    case 'REQUERIMENTO_CONTATO_DADOSCNIS_INICIAR':
      return { ...state, esperandoSolicitacao: true, alerta: {} };
    case 'REQUERIMENTO_CONTATO_DADOSCNIS_RECEBIDO':
      return { ...state, filiadoTO: action.data.filiadoTO, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CONTATO_DADOSCNIS_ERROR':
      return { ...state, error: action.data, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CONTATO_ATUALIZARCNIS_INICIAR':
      return { ...state, esperandoSolicitacao: true }
    case 'REQUERIMENTO_CONTATO_ATUALIZARCNIS_SUCESSO':
      return { ...state, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CONTATO_ATUALIZARCNIS_ERROR':
      return { ...state, error: action.data, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CONTATO_TITULAR_VALIDAR':
      return { ...state, esperandoSolicitacao: true, alerta: {} };
    case 'REQUERIMENTO_CONTATO_TITULAR_VALIDAR_SUCESSO':
      return { ...state, alerta: {}, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CONTATO_TITULAR_VALIDAR_ERROR':
      return { ...state, alerta: { message: action.data, severity: 'warning' }, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CONTATO_TITULAR_VALIDAR_ERROS':
      return {
        ...state,
        alerta: { message: action.data, severity: 'error' },
        error: typeof action.data == "string" ? action.data : 'MSG_ERRO_SERVIDOR',
        esperandoSolicitacao: false
      };
    default:
      return state;
  }

}